import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'

import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import { ICON_HEIGHT_24 } from '../../../../../Icon'

import { QA_NAME_MATCH_RULES_BUTTON } from './ListingProfileApplicantsMatchRules.constants'
import { useMatchRulesReevaluation } from './ListingProfileApplicantsMatchRules.hooks'
import {
  getIsMatchRulesOpen,
  getMatchRulesClosedSearchParams,
  getMatchRulesOpenedSearchParams,
  getMatchRulesTooltip,
} from './ListingProfileApplicantsMatchRules.utils'
import { ListingProfileApplicantsMatchRulesModal } from './ListingProfileApplicantsMatchRulesModal'

import SettingsIcon from '../../../../../../icons/settings.svg'

function ListingProfileApplicantsMatchRules({ listing, rules, onReevaluated }) {
  const { t } = useTranslation()

  const [searchParams, setSearchParams] = useSearchParams()

  const { handleStartReevaluation } = useMatchRulesReevaluation({
    onFinished: onReevaluated,
  })

  const isOpen = getIsMatchRulesOpen(searchParams)

  function handleOpen() {
    setSearchParams(getMatchRulesOpenedSearchParams, { replace: true })
  }

  function handleClose() {
    setSearchParams(getMatchRulesClosedSearchParams, { replace: true })
  }

  return (
    <>
      <Button.Flat
        isGrey
        beforeIconProps={{ Icon: SettingsIcon, height: ICON_HEIGHT_24 }}
        height={BUTTON_HEIGHT_32}
        qaName={QA_NAME_MATCH_RULES_BUTTON}
        text={t('RentalPortal.MatchRulesBtnKey')}
        tooltip={getMatchRulesTooltip({ rules, t })}
        onClick={handleOpen}
      />
      {isOpen ? (
        <ListingProfileApplicantsMatchRulesModal
          listing={listing}
          rules={rules}
          onClose={handleClose}
          onReevaluate={handleStartReevaluation}
        />
      ) : null}
    </>
  )
}

export default ListingProfileApplicantsMatchRules
